import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class UpdateOrderDeliveryPickup
*  Самовывоз: точка выдачи.
*/
export class UpdateOrderDeliveryPickup extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Pickup' })
  readonly kind: string = 'Pickup'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * warehouseId
  * Склад-точка из `pickupPoints` в `GET orders/config`. Можно не<br>передавать: тогда берётся первая доступная точка по порядку отгрузки —<br>так продолжают работать клиенты, которые ещё не умеют выбирать точку.<br>  */
  @ActiveField()
  warehouseId?: null | number
}
